/**
 * @file 피드백 게시판 상수·헬퍼
 * 상태 메타(라벨/색상)와 날짜 포맷 헬퍼를 모아둔다. 색은 ds 토큰과 동일 계열.
 */
import dayjs from "dayjs";

/** 상태 메타 — 서버 enum(REVIEW|IN_PROGRESS|DONE) 기준. 승인표(STATUS_META) 패턴과 동일. */
export const FEEDBACK_STATUS_META = {
    REVIEW:      { label: "검토중", color: "#64748b", bg: "#f1f5f9" },
    IN_PROGRESS: { label: "진행중", color: "#d97706", bg: "#fffbeb" },
    DONE:        { label: "완료",   color: "#16a34a", bg: "#f0fdf4" },
};

/** 상태 필터/선택 옵션 순서. */
export const FEEDBACK_STATUS_ORDER = ["REVIEW", "IN_PROGRESS", "DONE"];

export function statusMeta(status) {
    return FEEDBACK_STATUS_META[status] || FEEDBACK_STATUS_META.REVIEW;
}

/** 상대 시간 (방금 전 / n분 전 / n시간 전 / n일 전 / 날짜). */
export function formatRelativeTime(iso) {
    if (!iso) return "";
    const d = dayjs(iso);
    if (!d.isValid()) return "";
    const now = dayjs();
    const diffSec = now.diff(d, "second");
    if (diffSec < 60) return "방금 전";
    const diffMin = now.diff(d, "minute");
    if (diffMin < 60) return `${diffMin}분 전`;
    const diffHour = now.diff(d, "hour");
    if (diffHour < 24) return `${diffHour}시간 전`;
    const diffDay = now.diff(d, "day");
    if (diffDay < 7) return `${diffDay}일 전`;
    return d.format(now.year() === d.year() ? "M월 D일" : "YYYY.MM.DD");
}

/** 절대 시간 (툴팁용). */
export function formatDateTime(iso) {
    if (!iso) return "";
    const d = dayjs(iso);
    return d.isValid() ? d.format("YYYY.MM.DD HH:mm") : "";
}
